// extracted by mini-css-extract-plugin
export default {"search_input":"searchBar_search_input__W4jJ9"};